module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-up-0e1fea06cd83c50b388d612cc42c94ca.svg";